import React, { useEffect } from 'react';
import generatedPathMap from '../data/generated-path-map.json';

const defaultState = {
    allReleases: [],
    reducedReleases: [],
    pathMap: {},
};

interface IGlobalProvider {
    allReleases: IReleaseInfo[];
    reducedReleases: IMajorMinorReleaseInfo[];
    pathMap: Record<string, string>;
}

const GlobalContext = React.createContext<IGlobalProvider>(defaultState);

const RELEASES_URL = 'https://cdn1.onlineaccess1.com/cdn/base/tecton/releases.json';
const HOUR_CACHE_STRING = new Date().toISOString().substring(0, 13).replace(/\D/g, '');

const GlobalProvider: React.FC<{ children?: React.ReactNode | undefined }> = ({ children }) => {
    const [context, setContext] = React.useState<IGlobalProvider>({
        allReleases: [],
        reducedReleases: [],
        pathMap: generatedPathMap,
    });

    useEffect(() => {
        (async () => {
            const allReleasesRequest = await fetch(`${RELEASES_URL}?q=${HOUR_CACHE_STRING}`);
            const allReleases = await allReleasesRequest.json();
            const reducedReleases = reduceReleases(allReleases);
            setContext({ ...context, allReleases, reducedReleases });
        })();
    }, []);

    function reduceReleases(allReleases: IReleaseInfo[]) {
        const majorMinorReleases = allReleases.reduce<IDict<IMajorMinorReleaseInfo>>((result, release) => {
            const [major, minor, patch] = release.version.split('.');
            const majorMinor = `${major}.${minor}`;

            if (result[majorMinor]?.patch! > patch ?? false) return result;

            result[majorMinor] = { ...release, patch, majorMinor };
            return result;
        }, {});

        return Object.values(majorMinorReleases);
    }

    return <GlobalContext.Provider value={context}>{children}</GlobalContext.Provider>;
};

export default GlobalContext;

export { GlobalProvider };
